<template>
  <div class="mentions-legales container my-5 py-5">
    <h1 class="mb-4">Mentions légales</h1>

    <p>
      Le site internet <strong>livratos.fr</strong> est édité par la société
      <strong>Malaweb</strong>, immatriculée au Registre du Commerce et des
      Sociétés sous le numéro <strong>SIRET 89313539200015</strong>.
    </p>

    <p>
      Adresse de contact : <strong>contact@livratos.fr</strong> — Site :
      <strong>contact.livratos.fr</strong>
    </p>

    <h2 class="mt-5 mb-4">Réalisation du site</h2>
    <p>
      Le site a été conçu, développé et réalisé par
      <strong>l'agence digitale Malaweb</strong>. L'agence demeure propriétaire
      du design, des éléments graphiques et de l’architecture technique du site,
      sauf mention contraire ou contrat spécifique.
    </p>
    <p>Contact développeur : <strong>contact@malaweb.fr</strong></p>

    <h2 class="mt-5 mb-4">Hébergement</h2>
    <p>Le site est hébergé par :</p>
    <p>
      <strong>OVH</strong>
      2 rue Kellermann – 59100 Roubaix – France RCS Lille Métropole : 424 761
      419 00045
    </p>

    <h2 class="mt-5 mb-4">Protection des données personnelles (RGPD)</h2>
    <p>
      Livratos s'engage à respecter la législation française et européenne en
      matière de protection des données personnelles, notamment le
      <strong>Règlement Général sur la Protection des Données (RGPD)</strong>.
    </p>

    <p>
      Les données personnelles collectées via les formulaires (nom, prénom,
      adresse e-mail, numéro de téléphone) sont utilisées exclusivement pour
      traiter vos demandes de contact ou d’inscription.
    </p>

    <p>
      Ces données ne sont jamais vendues, partagées ou transmises à des tiers,
      en dehors des prestataires nécessaires au fonctionnement du service.
    </p>

    <p>
      Le site utilise <strong>Google Analytics</strong> afin de mesurer la
      fréquentation du site. Aucun ciblage publicitaire n’est activé.
    </p>

    <p>
      Conformément à la loi, vous disposez d’un droit d’accès, de rectification,
      d’opposition, de suppression et de portabilité de vos données. Vous pouvez
      exercer ces droits en nous contactant à
      <strong>contact@livratos.fr</strong>.
    </p>

    <h2 class="mt-5 mb-4">Copyright</h2>
    <p>
      Copyright © Malaweb. Tous droits réservés. Toute reproduction, totale ou
      partielle, sans autorisation préalable écrite, est strictement interdite
      conformément aux articles L335-2 et suivants du Code de la Propriété
      Intellectuelle.
    </p>

    <h2 class="mt-5 mb-4">Loi applicable</h2>
    <p>
      Les présentes mentions légales sont régies par la loi française. En cas de
      litige, seuls les tribunaux français seront compétents.
    </p>
  </div>
</template>

<script>
import { useMeta } from "vue-meta";
export default {
  name: "MentionLegale",
  setup() {
    useMeta({
      title: "Mentions légales – Livratos",
      description: [
        {
          content:
            "Livratos respecte la législation française et européenne en matière de protection des données personnelles (RGPD). Consultez nos mentions légales.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.livratos.fr/mentions-legales",
        },
      ],
    });
  },
};
</script>

<style lang="scss" scoped>
h1,
h2 {
  color: $color-primary;
}
p {
  color: $color-darker;
}
</style>
